import { z } from 'zod';

export const ChangeEmailSchema = 
z.object({
	newEMail: z.string().min(1, 'lbl_NewEmail').email('lbl_WrongFormatField'),
	confNewEMail: z.string().min(1, 'lbl_EnterConfirmEmail').email('lbl_RegistMailWorngfromat'),
}).refine((data) => data.newEMail === data.confNewEMail, {
	message: 'lbl_EMailNotMatch',
	path: ['confNewEMail']
});


export type SignUpInputs = z.infer<typeof ChangeEmailSchema>;